import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DataSourceWrapper from '../DataSourceWrapper';
import { StudyListPage, ViewerLayoutWrap, PDFWrap, PdfEdit } from '@ohif/ui';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import userSvg from './images/user.svg';
import { useAppConfig } from '@state';

import './MainWrap.less';

const MainWrap: React.FC = () => {
  const [activeTab, setActiveTab] = useState('worklist'); // 控制当前活动的 Tab
  const [iframeUrl, setIframeUrl] = useState<any>('');
  const [pdfIframeUrl, setPdfIframeUrl] = useState<any>('');
  const [appConfig] = useAppConfig();
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Link
          to="/"
          onClick={() => sessionStorage.removeItem('user')}
        >
          <span>退出</span>
        </Link>
      ),
    },
    {
      key: '2',
      label: (
        <div onClick={() => changeThumbnailLocation()}>
          <span>更改缩略图位置</span>
        </div>
      ),
    },
  ];

  const changeThumbnailLocation = () => {
    const newThumbnailLocation =
      localStorage.getItem('thumbnailLocation') === 'top' ? 'right' : 'top';
    localStorage.setItem('thumbnailLocation', newThumbnailLocation);
    localStorage.setItem('isUserSet', 'true');
  };

  const handleTabChange = (
    key: string,
    url: string,
    isDoubleClick?: boolean,
    studyInstanceUid?: string
  ) => {
    setActiveTab(key);
    if (key === 'viewer') {
      if (url) {
        setIframeUrl(url);
        if (isDoubleClick) {
          setPdfIframeUrl(
            '/ncpacsservice/reportPicServlet?reg_key=' +
            studyInstanceUid +
            '&output=pdfbyte#view=Fit'
          );
        }
      }
    } else if (key === 'pdf') {
      console.log('appConfig===', appConfig);
      if (url) {
        setPdfIframeUrl(url);
      }
    }
  };
  return (
    <div className="mainwrap-page">
      <div className="header-box">
        <div className="btn-box">
          <div
            className={activeTab === 'worklist' ? 'tab-btn-active' : 'tab-btn'}
            onClick={() => handleTabChange('worklist', '')}
          >
            检查列表
          </div>
          <div
            className={activeTab === 'viewer' ? 'tab-btn-active' : 'tab-btn'}
            onClick={() => handleTabChange('viewer', '')}
          >
            影像浏览
          </div>
          <div
            className={activeTab === 'pdf' ? 'tab-btn-active' : 'tab-btn'}
            onClick={() => handleTabChange('pdf', '')}
          >
            报告预览
          </div>
          {appConfig.isShowPdfEdit && (
            <div
              className={activeTab === 'pdfedit' ? 'tab-btn-active' : 'tab-btn'}
              onClick={() => handleTabChange('pdfedit', '')}
            >
              报告编辑
            </div>
          )}
        </div>
        <div className="icon-user">
          <Dropdown
            menu={{ items }}
            placement="bottomRight"
            arrow
          >
            <img
              src={userSvg}
              alt=""
            />
          </Dropdown>
        </div>
      </div>
      <div>
        <div
          style={{
            display: activeTab === 'worklist' ? 'block' : 'none',
            height: activeTab === 'worklist' ? '100%' : 0,
          }}
        >
          {/* <DataSourceWrapper
            children={StudyListPage}
            handleTabChange={handleTabChange}
          >
          </DataSourceWrapper> */}
          <StudyListPage handleTabChange={handleTabChange} />
        </div>
        <div
          style={{
            visibility: activeTab === 'viewer' ? 'visible' : 'hidden',
            height: activeTab === 'worklist' ? '100%' : 0,
          }}
        >
          <ViewerLayoutWrap iframeUrl={iframeUrl} />
        </div>
        <div
          style={{
            visibility: activeTab === 'pdf' ? 'visible' : 'hidden',
            height: activeTab === 'worklist' ? '100%' : 0,
          }}
        >
          <PDFWrap iframeUrl={pdfIframeUrl} />
        </div>
        {appConfig.isShowPdfEdit && (
          <div
            style={{
              display: activeTab === 'pdfedit' ? 'block' : 'none',
              height: activeTab === 'worklist' ? '100%' : 0,
            }}
          >
            <PdfEdit />
          </div>
        )}
      </div>
    </div>
  );
};

export default MainWrap;
